import styled from 'styled-components';

export const StyledTextAreaContainer = styled.div`
    .gi-textarea__input {
        width: 100%;
    }

    .gi-textarea .gi-textarea__label {
        width: 100%;
        text-align: left;
        padding-left: 0;
        color: ${({ theme }) => theme.primaryMain};
    }
`;

export const StyledDropdownContainer = styled.div`
    .gi-dropdown {
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: start;
    }
    .gi-dropdown__label {
        padding-left: 0;
        color: ${({ theme }) => theme.primaryMain};
    }
`;

export const StyledInputBoxContainer = styled.div`
    margin-top: 3rem;
    margin-bottom: 3rem;
`;

export const StyledModalContent = styled.div`
    margin-bottom: 2.5rem;
`;

export const StyledCharacterCounter = styled.div`
    margin-top: 0.5rem;
`;

export const StyledNoteSection = styled.div`
    padding: 0.8rem;
    border-left: ${({ theme }) => `3px solid ${theme.secondaryMain}`};
    background-color: ${({ theme }) => `${theme.secondaryLightest}`};
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

export const StyledMemberHeading = styled.div`
    margin-top: 1rem;
    border-bottom: 1px solid ${({ theme }) => `${theme.gray8}`};
`;

export const StyledFooterContainer = styled.div`
    display: flex;
    justify-content: end;
    align-items: baseline;
    gap: 1rem;

    form {
        display: flex;
        align-items: end;
        gap: 10px;
    }
`;

export const StyledModalWrapper = styled.div`
    .gi-modal__content {
        max-width: inherit;
    }
`;

export const StyledContainer = styled.div`
    margin-left: 35px;
    @media (max-width: 768px) {
        margin-left: 15px;
    }
`;

export const StyledRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const StyledColumn = styled.div`
    min-width: 0;
    overflow-wrap: break-word;
    flex: 1;
    @media (max-width: 768px) {
        padding: 2px;
    }
`;

export const StyledBoldUnderline = styled.div`
    text-decoration: underline;
`;

export const StyledTableSection = styled.section`
    margin: 1rem 0;
    table {
        margin: 0;
    }
    thead tr th {
        position: sticky;
        top: 0;
        background-color: white;
        font-weight: 400;
        border-bottom: 1px solid #d3d3d3;
    }
    th:first-child {
        padding-left: 10px;
    }
    tbody tr td {
        border: 1px solid #d3d3d3;
    }
`;

export const StyledTextCenter = styled.div`
    text-align: center;
`;

export const StyledLabelNone = styled.div`
    .gi-input {
        text-align: left;
        margin: 0;
    }
    label {
        display: none;
    }
`;
